module.exports = __webpack_public_path__ + "static/js/1.2ef6fe41.chunk.worker.js"